export default {
  name: 'easyboss',
  env: 'dev',
  baseURL: `http://shopee-dev.dingmai.com`,
  appId: 'wxbc7c3c0d99d32e78',
  wxMpRegisterUrlBase: `https://m-pre.easyboss.com`,
}
